/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetTopItemsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetTopItemsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    wardrobe: {
      __typename?: "WardrobeContentModule";
      boughtModule: {
        __typename?: "WardrobeBoughtModule";
        topItemsModule: {
          __typename?: "WardrobeTopItemsModule";
          topItemsLimit: number;
          remainingTopItemSpots: number;
          topItems: Array<{
            __typename?: "WardrobeGoto";
            skuId: string;
            shopProductVariant: {
              __typename?: "ShopProductVariant";
              sku: string;
              url: string;
              isGoToItem: boolean;
              mayHaveOutfits: boolean;
              image?: {
                __typename?: "ShopMedia";
                altText: string;
                baseUrl: string;
                mediaPath: string;
              } | null;
            };
            keptItem: {
              __typename?: "KeptItem";
              sku: string;
              orderId: string;
              orderType: string;
              returnInProgress: boolean;
            };
          }>;
          endCard: {
            __typename?: "WardrobeTopItemsEndCard";
            heading: string;
            subheading: string;
            illustration: Types.ModeIllustration;
          };
        };
      };
    };
  } | null;
};

export type TopItemFragment = {
  __typename?: "WardrobeGoto";
  skuId: string;
  shopProductVariant: {
    __typename?: "ShopProductVariant";
    sku: string;
    url: string;
    isGoToItem: boolean;
    mayHaveOutfits: boolean;
    image?: {
      __typename?: "ShopMedia";
      altText: string;
      baseUrl: string;
      mediaPath: string;
    } | null;
  };
  keptItem: {
    __typename?: "KeptItem";
    sku: string;
    orderId: string;
    orderType: string;
    returnInProgress: boolean;
  };
};

export type TopItemVariantFragment = {
  __typename?: "ShopProductVariant";
  sku: string;
  url: string;
  isGoToItem: boolean;
  mayHaveOutfits: boolean;
  image?: { __typename?: "ShopMedia"; altText: string; baseUrl: string; mediaPath: string } | null;
};

export type TopItemEndCardFragment = {
  __typename?: "WardrobeTopItemsEndCard";
  heading: string;
  subheading: string;
  illustration: Types.ModeIllustration;
};

export type KeptItemFragment = {
  __typename?: "KeptItem";
  sku: string;
  orderId: string;
  orderType: string;
  returnInProgress: boolean;
};

export const TopItemVariantFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItemVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isGoToItem" } },
          { kind: "Field", name: { kind: "Name", value: "mayHaveOutfits" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const KeptItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KeptItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "orderId" } },
          { kind: "Field", name: { kind: "Name", value: "orderType" } },
          { kind: "Field", name: { kind: "Name", value: "returnInProgress" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TopItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WardrobeGoto" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "skuId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductVariant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TopItemVariant" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "keptItem" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KeptItem" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItemVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isGoToItem" } },
          { kind: "Field", name: { kind: "Name", value: "mayHaveOutfits" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KeptItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "orderId" } },
          { kind: "Field", name: { kind: "Name", value: "orderType" } },
          { kind: "Field", name: { kind: "Name", value: "returnInProgress" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TopItemEndCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItemEndCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WardrobeTopItemsEndCard" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "subheading" } },
          { kind: "Field", name: { kind: "Name", value: "illustration" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetTopItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getTopItems" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "wardrobe" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boughtModule" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "topItemsModule" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "topItemsLimit" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "remainingTopItemSpots" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "topItems" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "TopItem" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endCard" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "TopItemEndCard" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItemVariant" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProductVariant" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "altText" } },
                { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isGoToItem" } },
          { kind: "Field", name: { kind: "Name", value: "mayHaveOutfits" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "KeptItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "KeptItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "sku" } },
          { kind: "Field", name: { kind: "Name", value: "orderId" } },
          { kind: "Field", name: { kind: "Name", value: "orderType" } },
          { kind: "Field", name: { kind: "Name", value: "returnInProgress" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WardrobeGoto" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "skuId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductVariant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "TopItemVariant" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "keptItem" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "KeptItem" } }],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TopItemEndCard" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "WardrobeTopItemsEndCard" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "heading" } },
          { kind: "Field", name: { kind: "Name", value: "subheading" } },
          { kind: "Field", name: { kind: "Name", value: "illustration" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetTopItemsQuery__
 *
 * To run a query within a React component, call `useGetTopItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTopItemsQuery, GetTopItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTopItemsQuery, GetTopItemsQueryVariables>(GetTopItemsDocument, options);
}
export function useGetTopItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTopItemsQuery, GetTopItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTopItemsQuery, GetTopItemsQueryVariables>(
    GetTopItemsDocument,
    options,
  );
}
// @ts-ignore
export function useGetTopItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopItemsQuery, GetTopItemsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTopItemsQuery, GetTopItemsQueryVariables>;
export function useGetTopItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTopItemsQuery, GetTopItemsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetTopItemsQuery | undefined, GetTopItemsQueryVariables>;
export function useGetTopItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTopItemsQuery, GetTopItemsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTopItemsQuery, GetTopItemsQueryVariables>(
    GetTopItemsDocument,
    options,
  );
}
export type GetTopItemsQueryHookResult = ReturnType<typeof useGetTopItemsQuery>;
export type GetTopItemsLazyQueryHookResult = ReturnType<typeof useGetTopItemsLazyQuery>;
export type GetTopItemsSuspenseQueryHookResult = ReturnType<typeof useGetTopItemsSuspenseQuery>;
export type GetTopItemsQueryResult = Apollo.QueryResult<
  GetTopItemsQuery,
  GetTopItemsQueryVariables
>;
